import { CCol, CRow } from '@coreui/react'
import { observer } from 'mobx-react-lite'
import { memo, useRef } from 'react'
import { useUserConfigProps } from './Context.js'
import { ButtonsConfig } from './Sections/ButtonsConfig.js'
import { GridConfigRows, GridSizeModal, type GridSizeModalRef } from './Sections/GridConfig.js'

export const SettingsButtonsPage = memo(function UserConfig() {
	return (
		<CRow className="split-panels">
			<CCol xl={6} className="primary-panel">
				<div className="flex-column-layout">
					<div className="fixed-header">
						<div className="d-flex justify-content-between">
							<div>
								<h4>Settings - Buttons</h4>
								<p>Settings apply instantaneously, don't worry about it!</p>
							</div>
						</div>
					</div>
					<div className="scrollable-content">
						<UserConfigTable />
					</div>
				</div>
			</CCol>
			{/* <CCol xs={12} xl={6} className="secondary-panel">
				<div className="secondary-panel-header">
					<h4>Remote control</h4>
					<p>Companion can be remote controlled in several ways. Below you'll find how to do it.</p>
				</div>
				<div className="secondary-panel-inner">
				</div>
			</CCol> */}
		</CRow>
	)
})

const UserConfigTable = observer(function UserConfigTable() {
	const userConfigProps = useUserConfigProps()
	const gridSizePopupRef = useRef<GridSizeModalRef>(null)

	if (!userConfigProps) return null

	return (
		<>
			<GridSizeModal ref={gridSizePopupRef} />
			<table className="table table-responsive-sm table-settings">
				<tbody>
					<ButtonsConfig {...userConfigProps} />
					<GridConfigRows {...userConfigProps} gridSizePopup={gridSizePopupRef} />
				</tbody>
			</table>
		</>
	)
})
